import { useState, useEffect } from 'react';
import { Modal, ModalFooter, ModalButton, Input } from './ui';

export default function PaymentReferenceModal({
  isOpen,
  onClose,
  poNumber,
  defaultReference,
  onConfirm,
}) {
  const [reference, setReference] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setReference(defaultReference || '');
      setSaving(false);
    }
  }, [isOpen, defaultReference]);

  const handleConfirm = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await onConfirm(reference.trim() || null);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Mark ${poNumber || 'PO'} as Paid?`}
      size="md"
    >
      <div className="space-y-3">
        <Input
          label="Payment Reference (optional)"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
          placeholder="Check #, ACH ref, etc."
          autoFocus
        />
        <p className="text-xs text-slate-500">
          Leave blank if you don't have a reference yet — you can add it later by editing the PO.
        </p>
        <ModalFooter>
          <ModalButton variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </ModalButton>
          <ModalButton variant="primary" onClick={handleConfirm} loading={saving}>
            Mark Paid
          </ModalButton>
        </ModalFooter>
      </div>
    </Modal>
  );
}
